import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { IResult } from 'app/shared/models/result.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { AppConfig } from 'app/app.config';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { saveAs } from 'file-saver';
@Component({
    selector: 'app-modal-report-liquidation',
    templateUrl: './modal-report-liquidation.template.html',
    styleUrls: ['./modal-report-liquidation.style.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ModalReportLiquidationComponet implements OnInit {
    /**Variable de trasporte de datos */
    private result: IResult;
    private pickerOptions = {
        dateFormat: 'dd.mm.yyyy',
        dateRange: false
    }
    private init = new Date();
    private end = new Date();
    @ViewChild(DatatableComponent, { static: false }) tableEmployees: DatatableComponent;
    constructor(private bsModalRef: BsModalRef
        , private spinner: NgxSpinnerService
        , private configGeneral: AppConfig
        , private liquidationService: LiquidationService) {
    }
    ngOnInit(): void {
    }
    private getFileLiquidations(row: IDtoEmployee): void {
        this.spinner.show();
        this.liquidationService.getFileLiquidations(this.configGeneral.formatDateyyyMMdd(this.init), this.configGeneral.formatDateyyyMMdd(this.end)).subscribe((res) => {
            if (res.isCorrect === true) {
                const file = res.data as any;
                const blob = this.configGeneral.b64toBlob(file.fileContents, file.contentType, '');
                saveAs(blob, file.fileDownloadName);
                this.spinner.hide();
            } else {
                this.configGeneral.newToast('Error', res.message, 'error');
                this.spinner.hide();
            }
        },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
}
